import ImageCursor from "./components/ImageCursor";
import CarouselManager from "./components/Carousel";
import Form from "./components/Form";
import Timeline from "./components/Timeline";
import Scroll from "./components/Scroll";
import Menu from "./components/Menu";
import Masonry from "./components/Masonry";

const main = {
  init: function() {
    Masonry.init();
    ImageCursor.init();
    CarouselManager.init();
    Scroll.init();
    Form.init();
    Timeline.init();
    Menu.init();
  },
};

export default main;



// WEBPACK FOOTER //
// ./src/scripts/main.js